import { isProdDeploy } from '@/utility/isSSR';

/**
 * Base URL for ride.auto, Outdoorsy's sister car-rental marketplace.
 * Staging deploys (and local dev) point at Ride's staging environment.
 */
export const getRideBaseUrl = () =>
  isProdDeploy() ? 'https://www.ride.auto' : 'https://staging.ride.auto';
